<template>
  <div>
    <el-form inline>
      <el-form-item label="">
        <el-button type="primary" @click="findlist">查询</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="listQuery.transTimeRange"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          :clearable="false"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'transTime')"
        />
      </el-form-item>
    </el-form>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="500"
      :data="tableData"
      :loading="loading"
    >
      <vxe-table-column field="cardNo" title="油卡号" min-width="120" />
      <vxe-table-column field="transNo" title="流水号" min-width="180" />
      <vxe-table-column field="transTime" title="发生时间" min-width="160" />
      <vxe-table-column field="amount" title="交易金额" min-width="110" />
      <vxe-table-column field="balance" title="交易后可用余额" min-width="140" />
      <vxe-table-column field="transDesc" title="交易说明" min-width="120" />
      <vxe-table-column field="remark" title="补充信息" min-width="110" />
    </vxe-table>
  </div>
</template>
<script>
import request from '@/utils/request'
import { timestampToTime } from '@/utils'
export default {
  name: 'Child',
  data() {
    return {
      tableData: [],
      loading: false,
      form: {},
      listQuery: {
        transTimeRange: [new Date((new Date).getFullYear(),0,1,0,0),new Date((new Date).getFullYear(),11,31,23,59)],
        transTimeStart: timestampToTime(new Date((new Date).getFullYear(),0,1,0,0).getTime()),
        transTimeEnd: timestampToTime(new Date((new Date).getFullYear(),11,31,23,59).getTime()),
      }
    }
  },
  created() {},
  methods: {
    // 获取页面信息
    getInfo(params) {
      this.listQuery.cardNo = params.cardNo
      this.listQuery.branchCode = params.branchCode 
      this.listQuery.driverPhone = params.phone
      this.initQuery = JSON.stringify(this.listQuery)
      this.findlist()
    },
    findlist(){
      this.loading = true;
      this.tableData = [];
      request({
        url: `/ntocc-tps-api/zhaoYou/cardTransactions`,
        params: this.listQuery,
        method: 'get'
      }).then(response => {
        this.tableData = response.data;
        this.loading = false;
        // this.$message({ message: response.msg, type: 'success' })
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin-top: 50px;
  }
</style>
